import Vue from 'vue';
import lang from '../lang-type';
const zh_data = require('./zh.json');
const en_data = require('./en.json');

let data = {
  cn: {
    lang_type: 'cn',
    login_image_guide: require('../assets/image/login_image_guide@2x.png'),
    elfinbook_index: '//www.elfinbook.com',
    英语: 'English',
    ...zh_data
  },
  en: {
    lang_type: 'en',
    login_image_guide: require('../assets/image/login_image_guide_en@2x.png'),
    elfinbook_index: ' //www.elfinbook.com/en',
    '¥6.00': '$3.00',
    '¥49.00': '$18.00',
    '@Copyright 杭州启汇科技有限公司 版权所有':
      '@Copyright HangZhou Qihui company',
    ...en_data
  }
};

Vue.prototype.$t = (key) => {
  return data[lang][key];
};
Vue.prototype.$t.lang = lang;

// 自动切换语言
if (!sessionStorage.getItem('autoChangeLang')) {
  sessionStorage.setItem('autoChangeLang', 1)
  if (navigator.language.indexOf('zh') > -1) {
    if (lang == 'en' && /\/en\//.test(location.pathname)) {
      window.location.href = window.location.href.replace('/en/', '/cn/');
    }
  } else {
    if (lang == 'cn') {
      window.location.href = window.location.href.replace('/cn/', '/en/');
    }
  }
}

console.log('当前语言:', lang);
export default data[lang];
